import React from 'react';
import PropTypes from 'prop-types';
import './Modal.css'; // Plik CSS dla stylów modala

function Modal({ isOpen, onClose, children, className = "modal-content", overlayClassName = "modal-overlay" }) {
  if (!isOpen) return null; // Nie renderuj modala, jeśli nie jest otwarty

  return (
    <div className={overlayClassName}>
      <div className={className}>
        <button className="modal-close-button" onClick={onClose}>
          &times;
        </button>
        {children}
      </div>
    </div>
  );
}

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired, // Czy modal jest otwarty
  onClose: PropTypes.func.isRequired, // Funkcja zamykająca modal
  children: PropTypes.node.isRequired, // Zawartość modala
  overlayClassName: PropTypes.string,
};

export default Modal;
